$giper_balls_shop $mol_page
	title @ \Магазин жизней
	auto /
		<= check_pending null
	body /
		<= Info $mol_view
			sub /
				<= Info_icon $mol_icon_heart
				<= Info_text $mol_paragraph
					title @ \Восстановите жизни мгновенно
		<= Description $mol_paragraph
			title @ \Жизни восстанавливаются каждые 30 минут. Не хотите ждать? Купите прямо сейчас!
		<= Products $mol_view
			sub /
				<= Product_1 $mol_view
					sub /
						<= Product_1_content $mol_view
							sub /
								<= Product_1_title $mol_paragraph
									title @ \1 жизнь
								<= Product_1_price $mol_view
									sub /
										<= Price_1_value $mol_paragraph
											title \200
										<= Price_1_currency $mol_paragraph
											title \₽
								<= Product_1_note $mol_paragraph
									title @ \200 ₽ за жизнь
						<= Buy_1 $mol_button_major
							title @ \Купить
							click? <=> buy_1? null
				<= Product_3 $mol_view
					sub /
						<= Product_3_content $mol_view
							sub /
								<= Product_3_badge $mol_paragraph
									title @ \Выгодно
								<= Product_3_title $mol_paragraph
									title @ \3 жизни
								<= Product_3_price $mol_view
									sub /
										<= Price_3_value $mol_paragraph
											title \400
										<= Price_3_currency $mol_paragraph
											title \₽
								<= Product_3_note $mol_paragraph
									title @ \~133 ₽ за жизнь
						<= Buy_3 $mol_button_major
							title @ \Купить
							click? <=> buy_3? null
				<= Product_5 $mol_view
					sub /
						<= Product_5_content $mol_view
							sub /
								<= Product_5_badge $mol_paragraph
									title @ \Лучшее предложение!
								<= Product_5_title $mol_paragraph
									title @ \5 жизней
								<= Product_5_subtitle $mol_paragraph
									title @ \Полное восстановление
								<= Product_5_price $mol_view
									sub /
										<= Price_5_value $mol_paragraph
											title \500
										<= Price_5_currency $mol_paragraph
											title \₽
								<= Product_5_note $mol_paragraph
									title @ \100 ₽ за жизнь
						<= Buy_5 $mol_button_major
							title @ \Купить
							click? <=> buy_5? null
		<= Checkout_info $mol_view
			sub <= checkout_info_content /
		<= Checkout $mol_view
			dom_name \div
			attr * id \yookassa-checkout
		<= Footer $mol_paragraph
			title @ \Оплата через ЮKassa • Моментальное зачисление
